import { toast } from "sonner";

/**
 * Clears the system clipboard only if its current content exactly matches the provided content.
 * Useful for scenarios like ESC key to clear preview, or item deletion, where we want to clear 
 * the clipboard if "this" item was what was copied.
 * 
 * @param content The content to match against the clipboard
 * @returns Promise<boolean> True if match was found and cleared, false otherwise or on error.
 */
export async function clearClipboardIfMatches(content: string | undefined): Promise<boolean> {
  if (!content) return false;

  try {
    const clipboardText = await navigator.clipboard.readText();
    if (clipboardText === content) {
      await navigator.clipboard.writeText('');
      toast("클립보드가 비워졌습니다.");
      return true;
    }
  } catch (err) {
    // Permission denied or other browser errors (e.g. not focused)
    console.warn('[ClipboardUtils] Conditional clear skipped/failed:', err);
  }

  return false;
}
